import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  TextInput,
  Button,
  SimpleGrid,
  Center,
  Group,
  Space,
  PasswordInput,
  Title,
  Container,
  Text,
} from '@mantine/core';

const Settings = () => {
  const navigate = useNavigate();
  const [passwordVerify, setPasswordVerify] = useState();
  const [isEdit, setIsEdit] = useState(false);
  const [siteDetails, setSiteDetails] = useState({});
  const password = 'admin@kiosk';
  const submitForm = () => {
    localStorage.setItem('siteDetails', JSON.stringify(siteDetails));
    navigate('/');
  };

  useEffect(() => {
    const siteDetailsData = localStorage.getItem('siteDetails');
    if (siteDetailsData) {
      setSiteDetails(JSON.parse(siteDetailsData));
    }
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setSiteDetails((prevUserProfileData) => ({
      ...prevUserProfileData,
      [name]: value,
    }));
  };

  return (
    <Box style={{ height: 'calc(100vh - 48px)', margin: '24px 0' }}>
      <Container
        className="home"
        style={{ display: 'flex', alignItems: 'stretch', flexDirection: 'column', height: '100%' }}
      >
        <Text>Version 0.03</Text>

        <Center>
          <Title order={1}>Configuration the site Details</Title>
        </Center>

        <Space h="xl" />
        {isEdit ? (
          <Box>
            <SimpleGrid cols={2}>
              <TextInput
                placeholder="Enter Site Id"
                label="Site Id"
                withAsterisk
                required
                name="siteId"
                value={siteDetails.siteId}
                onChange={handleInputChange}
              />
              <TextInput
                placeholder="Enter Site Name"
                label="Site Name"
                withAsterisk
                required
                name="siteName"
                value={siteDetails.siteName}
                onChange={handleInputChange}
              />
              <TextInput
                placeholder="Enter long"
                label="long"
                withAsterisk
                required
                name="long"
                value={siteDetails.long}
                onChange={handleInputChange}
              />
              <TextInput
                placeholder="Enter lat"
                label="lat"
                withAsterisk
                required
                name="lat"
                value={siteDetails.lat}
                onChange={handleInputChange}
              />
              <TextInput
                placeholder="Enter Site Name Arabic"
                label="Site Name Arabic"
                withAsterisk
                required
                name="siteNameArabic"
                value={siteDetails.siteNameArabic}
                onChange={handleInputChange}
              />
              <TextInput
                placeholder="Enter Com Port"
                label="Com Port"
                withAsterisk
                required
                name="comPortNumber"
                value={siteDetails.comPortNumber}
                onChange={handleInputChange}
              />
            </SimpleGrid>
            <Space h="xl" />
            <SimpleGrid cols={2}>
              <TextInput
                placeholder="Enter Kiosk Unique Code"
                label="Kiosk Unique Code"
                withAsterisk
                value={siteDetails.uniqueCode}
                name="uniqueCode"
                onChange={handleInputChange}
              />
              <PasswordInput
                placeholder="Enter Password"
                label="Password"
                withAsterisk
                value={passwordVerify}
                onChange={(e) => setPasswordVerify(e.target.value)}
              />
            </SimpleGrid>{' '}
          </Box>
        ) : (
          <Box>
            {siteDetails !== null ? (
              <SimpleGrid cols={2}>
                <TextInput
                  placeholder="Enter Site Id"
                  label="Site Id"
                  withAsteris
                  value={siteDetails.siteId || ''}
                  disabled
                />
                <TextInput
                  placeholder="Enter Site Name"
                  label="Site Name"
                  withAsterisk
                  value={siteDetails.siteName || ''}
                  disabled
                />
                <TextInput
                  placeholder="Enter long"
                  label="long"
                  withAsterisk
                  value={siteDetails.long || ''}
                  disabled
                />
                <TextInput
                  placeholder="Enter lat"
                  label="lat"
                  withAsterisk
                  value={siteDetails.lat || ''}
                  disabled
                />
                <TextInput
                  placeholder="Enter Site Name Arabic"
                  label="Site Name Arabic"
                  withAsterisk
                  value={siteDetails.siteNameArabic || ''}
                  disabled
                />
                <TextInput
                  placeholder="Enter Com Port"
                  label="Com Port"
                  withAsterisk
                  value={siteDetails.comPortNumber || ''}
                  disabled
                />
              </SimpleGrid>
            ) : null}
          </Box>
        )}

        <Space h="xl" />
        <Center>
          <Group>
            <Button onClick={() => navigate('/')} size="md">
              Home
            </Button>
            <Button onClick={() => setIsEdit(true)} size="md">
              Reset Configuration
            </Button>
            {isEdit ? (
              <Button onClick={() => setIsEdit(false)} size="md">
                Cancel
              </Button>
            ) : null}
            {isEdit ? (
              <Button
                onClick={submitForm}
                disabled={password !== passwordVerify}
                size="md"
                color="blue"
              >
                Save
              </Button>
            ) : null}
          </Group>
        </Center>
      </Container>
    </Box>
  );
};

export default Settings;
